import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "../Products/Products.css";
import saveimg from "../../../img/s4.png";
import sildeimg15 from "../../../img/r7.jpeg";
import sildeimg11 from "../../../img/s5.jpg";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function StarkeyHearingAids() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
       <Helmet>
      <title>Starkey Hearing Aids</title>
        <meta name="description" content="On the hunt for reliable hearing aids? Choose Starkey for AI-powered hearing aids that understand your needs. Don't wait – get tested at The Hearing Centre today!" />
        <meta property="og:title" content="Starkey Hearing Aids"></meta>
        <meta property="og:description" content="On the hunt for reliable hearing aids? Choose Starkey for AI-powered hearing aids that understand your needs. Don't wait – get tested at The Hearing Centre today!"></meta>
      </Helmet>
      <Header />
      <section className="phonak_hearing">
        <div className="container">
          <h1 className="Heading_text">Starkey</h1>
          <p className="Heading_pergrap">
            Starkey Hearing Technologies is an American privately owned company
            based in Eden Prairie,
          </p>
        </div>
      </section>

      <section className="HearingSolutions">
        <div className="container">
          <div className="row">
            <div className="img_solution">
              <h1>Starkey Hearing Aids</h1>
              <p>
                Starkey Hearing Technologies is an American privately owned
                company based in Eden Prairie, Minnesota that makes hearing
                aids, and is one of the largest hearing aid manufacturers in the
                world. When it comes to better hearing, everyone deserves an
                edge.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind Sigin_history">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={saveimg} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  ReSound OMNIA Hearing Aid: <br />
                  Mini RIE Rechargeable
                </h5>
                <p>
                  Masks muffle speech and block important lip-reading cues, both
                  key to hearing conversations. Livio Edge AI hearing aids make
                  it easier to hear — even if the person you’re talking to is
                  six feet away.
                </p>
              </div>
            </div>
          </div>

          <div className="menu_new">
            <ul>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Our custom devices won’t get tangled or pulled off when
                wearing or removing face masks.
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Edge Mode for masks delivers an on-demand boost for speech
                audibility with just a tap of your hearing aids.
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;They automatically optimize for social distancing,
                background noise, and other face mask challenges.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>Edge Mode for masks</h5>
                <p>
                  Our proprietary Edge Mode technology uses artificial
                  intelligence to boost clarity any time you need it. Just tap
                  your hearing aids and Edge Mode instantly scans the
                  environment, optimizing for masks, social distancing and
                  background noise to help make it easier to hear.
                </p>
                <p>Only available with Livio Edge AI</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg11} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg15} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>The perfect solution for masks</h5>
                <p>
                  If you want hearing aids that don’t fall off every time you
                  wear or remove your mask, custom rechargeable Livio Edge AI
                  hearing aids are the answer:
                </p>
              </div>
            </div>
          </div>

          <div className="menu_new">
            <ul>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;They sit inside your ear so they won’t interfere with your
                mask.
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Edge Mode technology helps solve communication challenges
                with hearing loss, social distancing and face masks.
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;They’re the only wireless custom rechargeable hearing aids
                available.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
